import {getApiErrorCode} from "./api.error";

const IDENTITY_ERROR_I18N_KEYS = {
  invalid_document: "identityError_invalid_document",
  underage: "identityError_underage",
  document_not_found: "identityError_document_not_found",
  document_already_registered: "identityError_document_already_registered",
  verification_expired: "identityError_verification_expired",
  verification_invalid: "identityError_verification_invalid",
  verification_required: "identityError_verification_required",
  kyc_unavailable: "identityError_kyc_unavailable",
  identity_validated: "identityError_identity_validated",
  rate_limit_exceeded: "identityError_rate_limit_exceeded",
};

/** Returns an i18n key — pass the result to `t()`. */
export const getIdentityErrorI18nKey = code => {
  if (!code) return "identityError_generic";
  return IDENTITY_ERROR_I18N_KEYS[code] ?? "identityError_generic";
};

export const getKycRejectionI18nKey = reason => {
  if (!reason) return "identityError_generic";
  return getIdentityErrorI18nKey(reason);
};

/** Maps a successful validate response that is not eligible to the right i18n key. */
export const getIdentityValidateFailureI18nKey = data => {
  if (data?.rejection_reason) {
    return getKycRejectionI18nKey(data.rejection_reason);
  }
  if (data?.is_adult === false) {
    return "identityError_underage";
  }
  return "identityError_generic";
};

/** User-facing message for identity API errors. */
export const formatIdentityApiError = (error, translate) => {
  const code = getApiErrorCode(error);
  if (code) return translate(getIdentityErrorI18nKey(code));

  if (import.meta.env.DEV && error instanceof Error && error.message && error.message !== "identityError_generic") {
    return `${translate("identityError_generic")} (${error.message})`;
  }

  return translate("identityError_generic");
};
